<template>
  <div style="padding: 10px 0 0 0;">
    <el-tabs type="border-card" @tab-click="handleClick">
      <el-tab-pane label="收款公司" name="0">
        <div v-loading="listContentLoading">
          <el-input
            class="search-el"
            size="mini"
            v-model="query.name"
            clearable
            placeholder="请输入名称"
          ></el-input>
          <el-button type="primary" size="mini" @click="getList()"
            >查询</el-button
          >

          <el-row>
            <el-table
              v-loading="loading"
              :data="list"
              border
              size="mini"
              :stripe="true"
              style="width: 100%; margin: 10px 0;"
            >
              <el-table-column
                prop="id"
                label="ID"
                align="center"
                min-width="5%"
              ></el-table-column>
              <el-table-column
                label="名称"
                align="center"
                min-width="25%"
                prop="company_name"
              >
              </el-table-column>

              <el-table-column
                prop="alipay_app_id"
                label="支付宝APPID"
                align="center"
                min-width="8%"
              ></el-table-column>

              <el-table-column
                prop="wechat_app_id"
                label="公众号APPID"
                align="center"
                min-width="12%"
              ></el-table-column>
              <el-table-column
                prop="wechat_appid"
                label="APPID"
                align="center"
                min-width="12%"
              ></el-table-column>

              <el-table-column
                prop="wechat_mch_id"
                label="微信支付商户号"
                align="center"
                min-width="8%"
              ></el-table-column>
            </el-table>
          </el-row>
          <el-row>
            <div class="block">
              <el-pagination
                background
                @current-change="getList"
                :current-page.sync="query.page"
                :page-size="query.limit"
                layout="total, prev, pager, next, jumper"
                :total="total"
              >
              </el-pagination>
            </div>
          </el-row>
        </div>
      </el-tab-pane>
      <el-tab-pane label="渠道收款" name="1">
        <div v-loading="listContentLoading1">
          <el-input
            class="search-el"
            size="mini"
            v-model="query1.like"
            clearable
            placeholder="请输入课程名称"
          ></el-input>
          <el-button type="primary" size="mini" @click="getList1()"
            >查询</el-button
          >
          <el-button type="primary" size="mini" @click="addTypeTarget(1)"
            >添加</el-button
          >

          <el-row>
            <el-table
              v-loading="loading1"
              :data="list1"
              border
              size="mini"
              :stripe="true"
              style="width: 100%; margin: 10px 0;"
            >
              <el-table-column
                prop="target_id"
                label="课程ID"
                align="center"
                min-width="5%"
              ></el-table-column>
              <el-table-column
                label="名称"
                align="center"
                min-width="25%"
                prop="title"
              >
              </el-table-column>

              <el-table-column label="图片" align="center" min-width="8%">
                <template slot-scope="{ row }">
                  <img :src="row.img_url" style="width: 40px;" alt="" />
                </template>
              </el-table-column>

              <el-table-column label="收款公司" align="center" min-width="15%">
                <template slot-scope="{ row }">
                  <div>
                    {{ row.company_name + "【ID: " + row.merchant_id + "】" }}
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="操作" align="center" min-width="14%">
                <template slot-scope="{ row }">
                  <el-button type="danger" size="mini" @click="del(row.id, 1)">
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
          <el-row>
            <div class="block">
              <el-pagination
                background
                @current-change="getList1"
                :current-page.sync="query1.page"
                :page-size="query1.limit"
                layout="total, prev, pager, next, jumper"
                :total="total1"
              >
              </el-pagination>
            </div>
          </el-row>
        </div>
      </el-tab-pane>
      <el-tab-pane label="线上课程【按讲师】" name="3">
        <div v-loading="listContentLoading3">
          <el-input
            class="search-el"
            size="mini"
            v-model="query3.like"
            clearable
            placeholder="请输入讲师名称"
          ></el-input>
          <el-button type="primary" size="mini" @click="getList3()"
            >查询</el-button
          >
          <el-button type="primary" size="mini" @click="addTypeTarget(3)"
            >添加</el-button
          >

          <el-row>
            <el-table
              v-loading="loading3"
              :data="list3"
              border
              size="mini"
              :stripe="true"
              style="width: 100%; margin: 10px 0;"
            >
              <el-table-column
                prop="target_id"
                label="讲师ID"
                align="center"
                min-width="5%"
              ></el-table-column>
              <el-table-column
                label="名称"
                align="center"
                min-width="25%"
                prop="title"
              >
              </el-table-column>

              <el-table-column label="图片" align="center" min-width="8%">
                <template slot-scope="{ row }">
                  <img :src="row.img_url" style="width: 40px;" alt="" />
                </template>
              </el-table-column>

              <el-table-column label="收款公司" align="center" min-width="15%">
                <template slot-scope="{ row }">
                  <div>
                    {{ row.company_name + "【ID: " + row.merchant_id + "】" }}
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="操作" align="center" min-width="14%">
                <template slot-scope="{ row }">
                  <el-button type="danger" size="mini" @click="del(row.id, 3)">
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
          <el-row>
            <div class="block">
              <el-pagination
                background
                @current-change="getList3"
                :current-page.sync="query3.page"
                :page-size="query3.limit"
                layout="total, prev, pager, next, jumper"
                :total="total3"
              >
              </el-pagination>
            </div>
          </el-row>
        </div>
      </el-tab-pane>
      <el-tab-pane label="线上课程" name="4">
        <el-descriptions title="收款公司">
          <el-descriptions-item label="ID">{{
            type425Merchant.id
          }}</el-descriptions-item>
          <el-descriptions-item label="名称">{{
            type425Merchant.company_name
          }}</el-descriptions-item>
        </el-descriptions>
      </el-tab-pane>
      <el-tab-pane label="线下课程" name="2">
        <el-descriptions title="收款公司">
          <el-descriptions-item label="ID">{{
            type425Merchant.id
          }}</el-descriptions-item>
          <el-descriptions-item label="名称">{{
            type425Merchant.company_name
          }}</el-descriptions-item>
        </el-descriptions>
      </el-tab-pane>
      <el-tab-pane label="电商收款" name="5">
        <el-descriptions title="收款公司">
          <el-descriptions-item label="ID">{{
            type425Merchant.id
          }}</el-descriptions-item>
          <el-descriptions-item label="名称">{{
            type425Merchant.company_name
          }}</el-descriptions-item>
        </el-descriptions>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      title="选择商品"
      :visible.sync="search.chooseOrgVisible"
      :close-on-click-modal="true"
      :before-close="addEditFormOnClose"
      width="75%"
    >
      <el-form :inline="true" :model="search.query">
        <!-- 模糊查询 -->
        <el-form-item>
          <el-input
            size="small"
            v-model="search.query.search"
            placeholder="请输入标题"
            clearable
            @blur="searchData()"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="searchData()">
            查询
          </el-button>
        </el-form-item>
      </el-form>

      <el-tabs v-model="search.activeName" @tab-click="handleClickType">
        <el-tab-pane
          v-if="currentType == 1"
          label="线上课程"
          name="1"
        ></el-tab-pane>
        <el-tab-pane
          v-if="currentType == 1"
          label="线下课"
          name="5"
        ></el-tab-pane>
      </el-tabs>

      <!--列表-->
      <el-table
        border
        :data="search.result.data"
        highlight-current-row
        v-loading="search.listLoading1"
        style="..."
      >
        <el-table-column label="ID" align="center">
          <template slot-scope="{ row }">
            {{ row.id }}{{ row.extra_type == 1 ? "【排期课】" : "" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          label="标题"
          align="center"
        ></el-table-column>
        <el-table-column label="图片" align="center">
          <template slot-scope="{ row }">
            <img :src="row.img_url" style="width: 40px;" alt="" />
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{ row }">
            <el-button type="primary" size="small" @click="selectProduct(row)">
              确定
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="searchData"
        :current-page.sync="search.query.page"
        :page-size="search.query.limit"
        layout="total, prev, pager, next, jumper"
        :total="search.result.total"
      >
      </el-pagination>
    </el-dialog>

    <el-dialog
      title="选择收款商"
      :visible.sync="type3.chooseOrgVisible"
      width="40%"
    >
      <el-select
        class="search-el"
        size="mini"
        v-model="type3.mch_id"
        placeholder="请选择收款商"
        clearable
      >
        <el-option
          v-for="item in list"
          :key="item.id"
          :label="item.company_name"
          :value="item.id"
        >
        </el-option>
      </el-select>

      <el-button type="primary" size="mini" @click="type3Select()">
        确定
      </el-button>
    </el-dialog>
  </div>
</template>

<script>
import { screenProductList } from "@/api/coupon";

import {
  getList,
  getType1TargetList,
  getType3TargetList,
  getTypePaymentMerchant,
  del,
  addTypeTarget,
} from "@/api/payMerchant";
export default {
  data: function () {
    return {
      currentType: 0,
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 20,
        name: "",
      },
      listContentLoading: false,

      list1: [],
      loading1: false,
      total1: 0,
      query1: {
        page: 1,
        limit: 20,
      },
      listContentLoading1: false,

      list3: [],
      loading3: false,
      total3: 0,
      query3: {
        page: 1,
        limit: 20,
      },
      listContentLoading3: false,

      search: {
        chooseOrgVisible: false,
        listLoading1: false,
        activeName: "1",
        query: {
          type: 1,
          search: "",
          page: 1,
          limit: 5,
          target_type: 1,
          extra_type: 2, // 限定非排期课，0-不限（即全部），1-限定搜排期课，2-限定搜非排期课
        },
        result: {
          total: 0,
          data: [],
        },
      },

      type3: {
        chooseOrgVisible: false,
        mch_id: 0,
      },

      addTypeTargetData: {
        type: 0,
        target_id: 0,
        merchant_id: 0,
      },

      type425Merchant: {
        id: 0,
        company_name: "",
      },
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    handleClickType(tab, event) {
      this.search.query.target_type = Number(tab.name);
      this.searchData();
    },
    addTypeTarget(type) {
      this.currentType = type;

      this.search.chooseOrgVisible = true;
      this.searchData();
    },
    // 弹窗关闭
    addEditFormOnClose() {
      this.search.query.page = 1;
      this.search.activeName = "0";
      this.search.query.type = 1;
      this.search.query.search = "";
      this.search.query.target_type = 1;

      this.search.result = {
        total: 0,
        data: [],
      };
      this.search.chooseOrgVisible = false;
      this.selectionContent = "";
    },
    // 查询方法
    searchData() {
      if (this.currentType == 3) {
        this.search.query.target_type = 51;
      }
      this.search.listLoading1 = true;
      screenProductList(this.search.query).then((response) => {
        this.search.result.data = response.data.list;
        this.search.result.total = response.data.total;
        this.search.listLoading1 = false;
      });
    },
    selectProduct(row) {
      this.addTypeTargetData.target_id = row.id;

      if (this.currentType == 1) {
        this.addTypeTargetData.type = this.currentType;
        this.addTypeTargetPost();
      } else {
        this.type3.chooseOrgVisible = true;
      }
    },
    type3Select() {
      this.addTypeTargetData.merchant_id = this.type3.mch_id;
      this.addTypeTargetPost();
    },

    addTypeTargetPost() {
      this.addTypeTargetData.type = this.currentType;
      addTypeTarget(this.addTypeTargetData).then((response) => {
        if (response.status == 2000) {
          this.search.chooseOrgVisible = false;
          this.addTypeTargetData = {
            type: 0,
            target_id: 0,
            merchant_id: 0,
          };

          if (this.currentType == 1) {
            this.getList1();
          }
          if (this.currentType == 3) {
            this.type3 = {
              chooseOrgVisible: false,
              mch_id: 0,
            };
            this.addEditFormOnClose();
            this.getList3();
          }

          this.$message({
            showClose: true,
            message: response.message,
            type: "success",
          });
        }
      });
    },

    handleClick(tab, event) {
      if (Number(tab.name) == 0) {
        this.getList();
      } else if (Number(tab.name) == 1) {
        this.getList1();
      } else if (Number(tab.name) == 3) {
        this.getList3();
      } else if ([4, 2, 5].indexOf(Number(tab.name)) >= 0) {
        getTypePaymentMerchant({ type: Number(tab.name) }).then((response) => {
          this.type425Merchant.id = response.data.id;
          this.type425Merchant.company_name = response.data.company_name;
        });
      }
    },
    getList() {
      this.loading = true;
      getList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },
    getList1() {
      this.loading1 = true;
      getType1TargetList(this.query1).then((response) => {
        this.list1 = response.data.list;
        this.total1 = response.data.total;
        this.loading1 = false;
      });
    },
    getList3() {
      this.loading3 = true;
      getType3TargetList(this.query3).then((response) => {
        this.list3 = response.data.list;
        this.total3 = response.data.total;
        this.loading3 = false;
      });
    },

    del(id, type) {
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        del({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            if (type == 1) {
              this.getList1();
            }
            if (type == 3) {
              this.getList3();
            }

            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },
  },
};
</script>

<style></style>>
